import React from 'react';
import { Tabs, Tab, Paper } from '@material-ui/core';
import { trackActivity } from '../../../utils/mixpanel';
const MliTab = ({ tabValue, onChangeTab }) => {
    return (
        <Paper square className='mli-tab' elevation={2}>
            <Tabs indicatorColor='primary' value={tabValue} onChange={(event, newValue) => onChangeTab(event, newValue)}>
                <Tab label='MLI' value="mli" style={{ fontFamily: 'Conv_IBMPlexSans-Medium' }} onClick={() => trackActivity('Form T015 Tab Clicked', { page_title: 'Mid Lease Inspection', event_type: 'Mid Lease Inspection Tab', event_desc: 'Clicked on Mid Lease Inspection Tab from Form T015' })} />
                <Tab label='Physical Review' value="review" style={{ fontFamily: 'Conv_IBMPlexSans-Medium' }} onClick={() => trackActivity('Form T015 Tab Clicked', { page_title: 'Physical Review', event_type: 'Physical Review Tab', event_desc: 'Clicked on Physical Review Tab from Form T015' })} />
            </Tabs>
        </Paper>
    )
}
export default MliTab;